/* KK 22.10.2026: Set-Tausch im Warenkorb (gehört zu snippets/kk-set-tausch.liquid). Immer geladen, damit es auch nach dem Neuladen des Warenkorb-Fensters funktioniert. */
(function () {
  if (window.kkSetSwap) return;
  window.kkSetSwap = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function post(url, payload) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { throw j; } return j; });
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-kk-set-swap-button]');
    if (!button) return;
    var box = button.closest('[data-kk-set-swap]');
    if (!box) return;
    event.preventDefault();

    var errorEl = box.querySelector('.kk-set-swap__error');
    errorEl.hidden = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    var updates = {};
    (box.getAttribute('data-lines') || '').split(',').forEach(function (pair) {
      if (!pair) return;
      var i = pair.lastIndexOf(':');
      var key = pair.slice(0, i);
      var qty = parseInt(pair.slice(i + 1), 10) || 1;
      updates[key] = Math.max(qty - 1, 0);
    });
    var bagKey = box.getAttribute('data-bag-key');
    var bags = parseInt(box.getAttribute('data-bags'), 10) || 0;
    if (bagKey && bags > 0) {
      updates[bagKey] = Math.max((parseInt(box.getAttribute('data-bag-qty'), 10) || 0) - bags, 0);
    }

    var inDrawer = !!box.closest('cart-drawer');

    post('cart/add.js', { items: [{ id: Number(box.getAttribute('data-set-variant')), quantity: 1 }] })
      .then(function () { return post('cart/update.js', { updates: updates }); })
      .then(function () {
        if (inDrawer) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } else {
          window.location.reload();
        }
      })
      .catch(function (err) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        errorEl.textContent = (err && (err.description || err.message)) || 'Das hat leider nicht geklappt. Bitte versuchen Sie es noch einmal.';
        errorEl.hidden = false;
        if (inDrawer) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
      });
  });
})();
